import React from "react";
import Member from "./Member";

const Members = () => {
  return (
    <section className="my-10">
      <div
        id="team"
        className="section relative pt-20 pb-8 md:pt-16 bg-white dark:bg-gray-800"
      >
        <div className="container xl:max-w-6xl mx-auto px-4">
          <header className="text-center mx-auto mb-12">
            <h2 className="text-2xl leading-normal mb-2 font-bold text-primary dark:text-gray-100">
              <span className="font-light">Our</span> Members
            </h2>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXLink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 100 60"
              style={{ margin: "0 auto", height: "35px" }}
              xmlSpace="preserve"
            >
              <circle
                cx="50.1"
                cy="30.4"
                r="5"
                className="stroke-primary"
                style={{
                  fill: "transparent",
                  strokeWidth: "2",
                  strokeMiterlimit: "10",
                }}
              ></circle>
              <line
                x1="55.1"
                y1="30.4"
                x2="100"
                y2="30.4"
                className="stroke-primary"
                style={{ strokeWidth: "2", strokeMiterlimit: "10" }}
              ></line>
              <line
                x1="45.1"
                y1="30.4"
                x2="0"
                y2="30.4"
                className="stroke-primary"
                style={{ strokeWidth: "2", strokeMiterlimit: "10" }}
              ></line>
            </svg>
          </header>
          <div>
            <div className="grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
              <Member
                image="https://i.ibb.co/Cz37fxC/IMG-20220531-103357.jpg"
                member_name="Mohammad Aiuvy"
                member_designation="Proprietor"
              ></Member>
              <Member
                image="https://i.ibb.co/wJ2RnQ2/IMG-20220531-103235.jpg"
                member_name="Mohammad Saifuddin Aiuvy"
                member_designation="CEO"
              ></Member>
              <Member
                image="https://i.ibb.co/SsF7xZw/IMG-20220531-103311.jpg"
                member_name="Mohammad Akib"
                member_designation="Delivery Man"
              ></Member>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Members;
